var fr_locale = require('./fr.json')
var en_locale = require('./en.json')

const locales = {
  'fr-FR': fr_locale,
  'en-GB': en_locale,
}

const Mustache = require('mustache');

var current_locale;

if (locales[navigator.language] === false || !locales.hasOwnProperty(navigator.language)) {
  current_locale = locales["en-GB"]
} else {
  current_locale = locales[navigator.language]
}

function l(token) {
  return Mustache.render("{{" + token + "}}", current_locale)
}

function l_html(token) {
  return Mustache.render(token, current_locale)
}

export { l, l_html };
